module.exports = __webpack_public_path__ + "images/project/empty-995c169cd9115a1bfba93fae4ca44722.svg";